import { useTranslation } from 'react-i18next';
import { GoogleIcon } from './GoogleIcon';
import type { ISsoButtonsProps } from './ISsoButtonsProps';
import { MicrosoftIcon } from './MicrosoftIcon';

/** «Продовжити з Google» і «Продовжити з Microsoft» (прототип v4): кнопки 36px з логотипами; вимкнений постачальник не показується. */
export function SsoButtons({ providers, onSso }: ISsoButtonsProps) {
  const { t } = useTranslation();
  if (!providers.google && !providers.microsoft) return null;
  return (
    <div className="au__sso">
      {providers.google && <button type="button" className="au__ssobtn" onClick={() => onSso('google')}><GoogleIcon />{t('auth.google')}</button>}
      {providers.microsoft && <button type="button" className="au__ssobtn" onClick={() => onSso('microsoft')}><MicrosoftIcon />{t('auth.microsoft')}</button>}
    </div>
  );
}
